<template>
  <div :class="['campaign-chip', themeClass, compactClass]">
    <div class="campaign-chip__title">
      <oie-use-svg :svg="config.icon"></oie-use-svg>
      <span>{{ config.title }}</span>
    </div>
    <div class="campaign-chip__text" v-html="config.text"></div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    themeClass() {
      return `campaign-chip--${this.config.theme}`
    },
    compactClass() {
      return this.compact && `campaign-chip--compact`
    }
  }

}
</script>

<style lang="scss">
.campaign-chip {
  padding: measure(quarter);
  transition: all .2s ease;
}

.campaign-chip--compact {
  padding: measure(eighth) measure(quarter);
}

.campaign-chip--red {
  background-color: color(background-white);
  border: 1px solid color(campaign-red);
  color: color(campaign-red);
}

.campaign-chip--green {
  background-color: color(campaign-green-discreet);
  border: 1px solid color(campaign-green-accent);
  color: color(text);
}

.campaign-chip__title {
  display: flex;
  align-items: center;
}

.campaign-chip__title > span{
  font-weight: 700;
  word-break: break-word;

}

.campaign-chip__title > svg {
  margin-right: measure('quarter');
}

.campaign-chip__text  p {
  margin: 0;
  color: color(text);
  word-break: break-word;
}
</style>
